<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvCutOvers.details.tenant_operator') }}</label></td>
      <td>{{ details.tenant_operator }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvCutOvers.details.business_day') }}</label></td>
      <td>{{ details.business_day | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvCutOvers.details.cut_over_dttm') }}</label></td>
      <td>{{ details.cut_over_dttm | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'EmvCutOVerDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style></style>
